import { render, staticRenderFns } from "./DocumentHistoryList.vue?vue&type=template&id=1b355316&scoped=true"
import script from "./DocumentHistoryList.vue?vue&type=script&lang=js"
export * from "./DocumentHistoryList.vue?vue&type=script&lang=js"
import style0 from "./DocumentHistoryList.vue?vue&type=style&index=0&id=1b355316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b355316",
  null
  
)

export default component.exports